import ChooseNewPassword from './ResetAndChoosePassword'

export default ChooseNewPassword
